const main = 'warehouses'
const relativeRoutes = {
  relativePage: `${main}/*`,
  relativeList: `${main}`,
  relativeDetail: ':id',
  relativeDetailWithTab: ':id/tab-:activeTab',
  relativeListWithTab: 'tab-:activeTab',
}

const routes = {
  List: `/${main}`,
  ListWithTab: `/${main}/${relativeRoutes.relativeListWithTab}`,
  Details: `/${main}/${relativeRoutes.relativeDetail}`,
  DetailWithTab: `/${main}/${relativeRoutes.relativeDetailWithTab}`,
}

const WarehousesRoutes = { ...relativeRoutes, ...routes }

export default WarehousesRoutes
